import axios from 'axios';

class ReportService {
  getSpecialistChartData(year) {
    return axios.get(`report/specialist/chart-data?year=${year}`);
  }
  getScopeFilters(id) {
    if (id == undefined) {
      return axios.get(`report/scope-filters`);
    }
    return axios.get(`report/scope-filters?program=${id}`);
  }
  getSpecialistPrograms(page, pageSize) {
    return axios.get(
      `report/programs/specialist?page=${page}&pageSize=${pageSize}`
    );
  }
  getSpecialistPayment(page, pageSize, payload) {
    return axios.get(
      `report/payments/specialist?page=${page}&pageSize=${pageSize}${payload}`
    );
  }
  getSpecialistPaymentSummary() {
    return axios.get(`report/payments/specialist/summary`);
  }
  getListFilters(filter, payload) {
    return axios.post(
      `report/list-filters` + (filter == 'pending' ? '?status=open' : ''),
      payload ? payload : {}
    );
  }
  getListReports(page, pageSize, req, tagsParams, payload) {

    let body = {};
    if (tagsParams && tagsParams.tags) {
      const {tags} = tagsParams; 
      body.tags = tags;
    }

    if(payload){
      body.locker = payload.locker;
      body.locker_jwt = payload.locker_jwt;
    }

    return axios.post(
      `report/filter?page=${page}&pageSize=${pageSize}${req}`,
      body ? body : {}
    );
  }
  getReportsExport() {
    return axios.get(`report/export`);
  }
  getScoreHistory() {
    return axios.get(`report/score-history`);
  }
  getReportsDuplicate(id, pageSize, req) {
    return axios.get(
      `/report/${id}/dup-titles-selection?pageSize=${pageSize}${req}`
    );
  }
  getWeakness(desc, pageSize) {
    return axios.get(
      `report/weakness-list?search=${desc}&pageSize=${pageSize}`
    );
  }
  getReportDetail(id, payload) {   
    return axios.post(`report/details/${id}`, payload);
  }
  postReport(payload) {
    return axios.post(`report`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  postUrlToBase64(url) {
    return axios.post(`report/fileToBase64`, { url: url });
  }
  getReportJira(reportId) {
    return axios.get(`report/send-to-jira/${reportId}`);
  }
  getOverview() {
    return axios.get(`report/overview`);
  }
  getSummaryBounties() {
    return axios.get(`company/reports/summary/bounties`);
  }
  postEventReport(payload) {
    return axios.post(`report/event`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
  putTags(id, payload) {
    return axios.put(`report/tags/${id}`, payload);
  }
}

export default new ReportService();
